
interface FeatureFlags {
  bootcamp_mode: boolean;
}

const featureFlags: FeatureFlags = {
  bootcamp_mode: false,
};

export default featureFlags;
